import { action, computed, makeObservable, observable } from 'mobx';
import { Service } from 'typedi';

export type TSessionState =
  | { status: 'checking' }
  | { status: 'anonymous'; error?: string }
  | { status: 'signedIn'; roles: string[] };

@Service()
export class SessionStore {
  private _state: TSessionState = { status: 'checking' };

  constructor() {
    makeObservable<SessionStore, '_state'>(this, {
      _state: observable.ref,
      state: computed,
      roles: computed,
      setState: action,
    });
  }

  get state(): TSessionState {
    return this._state;
  }

  /** Realm roles of the signed-in user; none otherwise. */
  get roles(): string[] {
    return this._state.status === 'signedIn' ? this._state.roles : [];
  }

  setState = (state: TSessionState): void => {
    this._state = state;
  };
}
